import { Component, inject } from '@angular/core';

import { RouterOutlet } from '@angular/router';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AuthService } from './services/auth/auth.service';
import { ThemeService } from './theme/theme.service';
import { DevInstrumentationService } from './services/error/dev-instrumentation.service';
import { RealtimePermissionSyncService } from './services/supabase/realtime-permission-sync.service';
import { AppUpdateService } from './services/app-update.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, MatProgressSpinnerModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  readonly auth = inject(AuthService);

  // Inject ThemeService so it initializes on app startup
  private readonly theme = inject(ThemeService);

  // Dev-only: log every fetch, route change, click, and unhandled error to logs/app.log
  private readonly instrumentation = inject(DevInstrumentationService);

  // Keep the JWT in sync with live role / permission / ownership changes.
  private readonly realtimeSync = inject(RealtimePermissionSyncService);

  // PWA update prompt — listens for new SW versions and offers a reload.
  private readonly appUpdate = inject(AppUpdateService);

  constructor() {
    this.instrumentation.install();
    this.appUpdate.install();
    void this.realtimeSync;
  }
}
